import React, { useState, useEffect } from 'react';

import { convertImageToWebP } from '../../utils/imageCompressor.ts';

interface ImageUploadProps {
    setImagen: (file: File | null) => void;
    currentImage?: string; // Añadido para la imagen actual
}

const ImageUpload: React.FC<ImageUploadProps> = ({ setImagen, currentImage }) => {
    const [previewUrl, setPreviewUrl] = useState<string | null>(currentImage || null);

    // Cuando se actualice la imagen, generamos el preview
    useEffect(() => {
        if (!previewUrl) return;
        return () => {
            URL.revokeObjectURL(previewUrl);
        };
    }, [previewUrl]);

    return (
        <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
                
            </label>
            <div className="flex items-center justify-center w-full">
                <label
                    htmlFor="file-upload"
                    className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-lg cursor-pointer hover:bg-gray-100"
                >
                    {previewUrl ? (
                        <img
                            src={previewUrl}
                            alt="Preview"
                            className="object-cover w-full h-full rounded-lg"
                        />
                    ) : (
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                                className="w-8 h-8 mb-3 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M7 16V4m0 0L3 8m4-4l4 4m6 8v-8m0 0l4 4m-4-4l-4 4"
                                />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500">
                                <span className="font-semibold">Click para subir</span> o arrastra y suelta
                            </p>
                            <p className="text-xs text-gray-500">PNG, JPG, WEBP (se optimiza a WebP)</p>
                        </div>
                    )}
                    <input
                        id="file-upload"
                        type="file"
                        accept="image/*"
                        onChange={async (e) => {
                            const file = e.target.files?.[0] || null;
                            if (file) {
                                const webpFile = await convertImageToWebP(file);
                                setImagen(webpFile);
                                setPreviewUrl(URL.createObjectURL(webpFile));
                            } else {
                                setImagen(null);
                                setPreviewUrl(null);
                            }
                        }}
                        className="hidden"
                    />
                </label>
            </div>
        </div>
    );
};

export default ImageUpload;
